import { client } from "#api/client.ts";
import type { AuthorizationFailureReasons } from "#api/types.ts";
import { usePaths } from "#paths.ts";
import { redirectOnForbidden } from "@sg-protect/core";
import { useEffect, useState } from "react";

const TENANT_FORBIDDEN_REASONS = ["invalidSgTenant", "notConsented"] as const satisfies AuthorizationFailureReasons[];

// False until the middleware is in, so no request goes out without it.
export function useForbiddenTenantRedirect() {
    const { root } = usePaths();
    const [isInstalled, setIsInstalled] = useState(false);

    // Not a layout effect: a page that suspends hides this tree, which would eject the middleware before the 403 arrives.
    useEffect(() => {
        const middlewares = TENANT_FORBIDDEN_REASONS.map(expectedFailureReason =>
            redirectOnForbidden<AuthorizationFailureReasons>({ expectedFailureReason, to: root })
        );

        middlewares.forEach(middleware => client.use(middleware));
        setIsInstalled(true);

        return () => {
            middlewares.forEach(middleware => client.eject(middleware));
        };
    }, [root]);

    return isInstalled;
}
